<template>

  <KCircularLoader :delay="false" />

</template>


<script>

  export default {
    name: 'ContentViewerLoading',
  };

</script>
